import React from "react";
import "../Styles/BluesArt.css";
import { Row, Col } from "react-bootstrap";
import ModalImage from "react-modal-image";

import BluesArtBanner from "../Assets/BluesArt/bluesartbanner.svg";
import mobilebanner from "../Assets/BluesArt/mobilebanner.svg";

// 🎨 Import all artwork images
import BA23 from "../Assets/BluesArt/ba23.png";
import BA23B from "../Assets/BluesArt/ba23B.png";
import BA24 from "../Assets/BluesArt/ba24.png";
import BA24B from "../Assets/BluesArt/ba24b.png";
import BA20 from "../Assets/BluesArt/ba20.png";
import BA20B from "../Assets/BluesArt/ba20B.png";
import BA19 from "../Assets/BluesArt/ba19.png";
import BA19B from "../Assets/BluesArt/ba19B.png";
import BA18 from "../Assets/BluesArt/ba18.png";
import BA18B from "../Assets/BluesArt/ba18B.png";
import BA17 from "../Assets/BluesArt/ba17.png";
import BA17B from "../Assets/BluesArt/ba17B.png";
import BA16 from "../Assets/BluesArt/ba16.png";
import BA16B from "../Assets/BluesArt/ba16B.png";
import BA15 from "../Assets/BluesArt/ba15.png";
import BA15B from "../Assets/BluesArt/ba15B.png";
import BA14 from "../Assets/BluesArt/ba14.png";
import BA14B from "../Assets/BluesArt/ba14B.png";
import BA13 from "../Assets/BluesArt/ba13.png";
import BA13B from "../Assets/BluesArt/ba13B.png";
import BA12 from "../Assets/BluesArt/ba12.png";
import BA12B from "../Assets/BluesArt/ba12B.png";
import BA11 from "../Assets/BluesArt/ba11.png";
import BA11B from "../Assets/BluesArt/ba11B.png";


import BA25 from "../Assets/BluesArt/ba25.png";

// 🧩 Artwork Data Array — All client content EXACTLY preserved
const artworks = [
    {
    id: "sunil-padwal",
    layout: "image-right",
    imgSmall: BA25,
    imgLarge: BA25,
    title: "DHRUVI ACHARYA",
    content: `
    <p class='boldnmes'>ABOUT THE POSTER:</p>
The Mahindra Blues Art 2025 poster has a female blues guitarist take the stage against the backdrop of Mumbai’s skyline. The sun sets in a blaze of colours, casting a golden glow over the city as starry clouds appear, heralding the approaching night sky. The names of all the musicians who have performed at the festival from 2011 onwards, including Buddy Guy, Walter Trout, and Blackstratblues weave across the sky, serving as a tribute. In the foreground, a whimsical touch is added with animated flowers symbolizing the festival's joyous celebration of music, which unites people from all walks of life through the power of blues.

<br></br>
 <p class='boldnmes'>ABOUT THE ARTIST - DHRUVI ACHARYA</p>
Dhruvi Acharya's art explores the psychological and emotional world of the urban woman, confronting issues like discord and pollution with subtle, wry humour. Her work makes thoughts visible, allowing protagonists to metamorphose by this internal logic. Acharya earned her MFA from the Maryland Institute College of Art in the USA, and her pieces have been exhibited globally at institutions including the Queens Museum, the San Jose Museum, and India's NGMA. She has held solo shows with Chemould and Nature Morte. She lives and works in Mumbai.
`
  },
  {
    id: "sunil-padwal",
    layout: "image-left",
    imgSmall: BA24,
    imgLarge: BA24B,
    title: "SUNIL PADWAL",
    content: `
Sunil Padwal did his foundation course at the Sir J J School of Fine Arts in 1986 and completed his BFA from the J J Institute of Applied Art in 1989. Padwal has lived in Bombay for all of his life. The artist’s daily engagement with this city is at the core of his practice. His preoccupation with collecting the city’s collective past through found objects and documents in different forms always leads to an exciting narrative. He is interested in this narrative, along with the current observations of the city. Padwal believes that his drawings are fictional, but the source of each drawing is rooted in things he sees every day. He says, “All our memories and personal experiences add layers to our vision. We create structures in our minds—one attempt to keep improvising within these structures, like in Indian classical music. The viewer’s engagement and imagination add dimensions to these semi-fictional stories.”
<br></br>
<p class='boldnmes'>About his Mahindra Blues Poster:</p>
In the ever-changing cityscape, it's hard to ignore the cranes and construction sites. A tower crane carrying a guitar is a symbolic representation of the Mahindra Blues festival. Perhaps the blues music will bring some relief from the grey skies, and the cacophony of noise in the city will sound more pleasant for a few days. This is illustrated by the visual of a rickshaw horn transforming into a musical horn/trombone.
`
  },
  {
    id: "aashti-miller",
    layout: "image-right",
    imgSmall: BA23,
    imgLarge: BA23B,
    title: "Aashti Miller",
    content: `
Aashti Miller is an architect, illustrator and graphic designer. She was born and raised in Mumbai, and studied Architecture at Cornell University in Ithaca, New York. She is the sole force behind MillerInk, an illustration and graphic design studio. She constructs her drawings in an attempt to make sense of the unexpected collision of her two seemingly disparate worlds. As a result, her aesthetic and style have evolved into detailed drawings that tread the fine line between constructed and painted, digital and analog, two and three dimensional. Her work is heavily inspired by and explores spaces, places, and faces.
`
  },
  {
    id: "ba20",
    layout: "image-only",
    imgSmall: BA20,
    imgLarge: BA20B,
    title: "Blues Art 2020"
  },
  {
    id: "ashwam",
    layout: "image-left",
    imgSmall: BA19,
    imgLarge: BA19B,
    title: "Ashwam Shrikant Salokhe",
    content: `
The artist, Ashwam Shrikant Salokhe, finds inspiration for this year’s Mahindra Blues poster from local trains: “I’m a Mumbaikar, every day I travel by train. The way she runs on the tracks and honks always gives me a feeling of Blues music going on around me. You can really hear the drum beat when she runs and the saxophone trumpet when she honks, while people inside her talk, sing, laugh - that creates the blues, and this is all going inside me. In the poster you will see the silhouette of a person, and inside him a Mumbai train station platform, and on the railway track, a trumpet instead of a train.”
`
  },
  {
    id: "jenny-bhatt",
    layout: "image-right",
    imgSmall: BA18,
    imgLarge: BA18B,
    title: "Jenny Bhatt",
    content: `
Jenny Bhatt has held 18 solo exhibitions to date. She has participated in several group exhibitions including those in New York, Sydney, London, Amsterdam and Berlin. Her work has been included in auctions, including those by Christie’s.
<br></br>
She has written on art, humour and spirituality in publications including The Times of India group, DNA and Verve magazine. Her poems have been published in the literary journals including The Little Magazine and The Brown Critique. She has illustrated 9 children’s books and wrote a book on humorous art.
`
  },
  {
    id: "rajmahamad",
    layout: "image-left",
    imgSmall: BA17,
    imgLarge: BA17B,
    title: "Rajmahamad Pathan",
    content: `
Artist Rajmahamad Pathan’s take on the Mahindra Blues shows a Koli fisherwoman with attitude. Against the backdrop of the sea link, Rajmahamad brings out the unmistakable Mumbai connect. He uses only microtip and ball point pens to fill in the colours, shades and textures making it a slow laborious process.
`
  },
  {
    id: "aditi-singh",
    layout: "image-right",
    imgSmall: BA16,
    imgLarge: BA16B,
    title: "Aditi Singh",
    content: `
<p data-aos="fade-up" data-aos-duration="2000" class="artist_bio_ba aos-init aos-animate">Moving through a blues-soaked world,<br>A planet where roses touch a grief<br>and scarlet meets a sea.<br>Moving through a blues-soaked world<br>at a plantation in a song,<br>In the attention of a heart, in the forest of a memory<br>In the glittering labour of hands,<br>As narrative, as ballad,<br>As a chant, as a string<br>As a shout<br>In the dark.<br>Moving through a blues-soaked world,<br>Where among days,<br>Living only the force<br>of days.<br>Most lyrical,<br>Most difficult.</p>
`
  },
  {
    id: "sharmistha-ray",
    layout: "image-left",
    imgSmall: BA15,
    imgLarge: BA15B,
    title: "Sharmistha Ray",
    content: `
Sharmistha Ray's poster for the Mahindra Blues Festival is a synthesis of art and design concepts inspired by Mumbai and music. Using the visual of the ocean dotted with coloured fishing boats - a unique signature of Mumbai's urban landscape - Ray has created a dynamic visual adapted from an original painting to complement the spirit of a Blues festival in Mumbai. Painting in the abstract, for Ray, also has close links with music. The painter's palette knife is akin to a conductor's baton: colour, temperature, gesture, mood, texture and myriad layers crescendo towards a total symphony. The semi-transparent font, which was created with an urban skyline stencil and a gritty texture to reflect Mumbai's urban grit, was superimposed on the visual to mimic a contemporary light projection upon the water.
<br></br>
Ray is an artist, writer and curator living in Mumbai and New York. In 2014, Ray was also commissioned by the Berklee College of Music to design a special poster for the historic event "A.R. Rahman Meets Berklee" at Boston Symphony Orchestra, USA. She is a TED Fellow and has won numerous accolades including a Montblanc Young Artist World Patronage Award. Her works are a part of private and corporate collections all around the world.
`
  },
  {
    id: "brinda-miller",
    layout: "image-right",
    imgSmall: BA14,
    imgLarge: BA14B,
    title: "Brinda Miller",
    content: `
The 'havaldar' blowing a whistle; the 'horn ok please'; the temple bell; the flute seller and various vehicles honking; the crow cawing - Renowned Mumbai based artist Brinda Miller presents an experiment in mixed media, creating a montage of images related to the sounds of Mumbai. Her vision brings to life the spirit of Blues music in the everyday sounds of the cosmopolitan city that has become the home of this genre in India. Exclusive, limited edition prints signed by Brinda will be available for purchase at the Festival venue.
`
  },
  {
    id: "jehangir-jani",
    layout: "image-left",
    imgSmall: BA13,
    imgLarge: BA13B,
    title: "Jehangir Jani",
    content: `
Noted Mumbai based artist Jehangir Jani <a class='link_ba' href='http://www.jehangirjani.com' target='_blank'>(www.jehangirjani.com)</a>  has beautifully brought out the connect between the Blues and the city of Mumbai in these Festival Posters specially created for the Mahindra Blues Festival. He has used popular Mumbai icons along with musical instruments most commonly used in creating the Blues. Exclusive, limited edition prints, signed by Jehangir, will be available for purchase at the Festival venue.
`
  },
  {
    id: "ba-2011-2012",
    layout: "two-images",
    imgPairs: [
      { small: BA12, large: BA12B, alt: "Blues Art 2012" },
      { small: BA11, large: BA11B, alt: "Blues Art 2011" }
    ]
  }
];

function BluesArt() {
  return (
    <div>
      <div className="bannerMainAbout"></div>
      <section className="bluesArtMain">
        <img
          data-aos="zoom-in"
          data-aos-duration="3000"
          src={BluesArtBanner}
          className="bluesart_banner desktop"
          alt="blues art heading"
        />
        <img
          data-aos="zoom-in"
          data-aos-duration="3000"
          src={mobilebanner}
          className="bluesart_banner mobile"
          alt="blues art heading"
        />

        <div className="content_blues_art">
          {artworks.map((art) => {
            if (art.layout === "image-only") {
              return (
                <div key={art.id} className="spaceSingleBa">
                  <ModalImage
                    hideDownload="true"
                    small={art.imgSmall}
                    large={art.imgLarge}
                    alt={art.title}
                  />
                </div>
              );
            }

            if (art.layout === "two-images") {
              return (
                <Row key={art.id} className="space_ba_info">
                  {art.imgPairs.map((img, i) => (
                    <Col key={i} sm={12} xs={12} md={12} lg={6} xl={6}>
                      <ModalImage
                        hideDownload="true"
                        small={img.small}
                        large={img.large}
                        alt={img.alt}
                      />
                    </Col>
                  ))}
                </Row>
              );
            }

            const imageFirst = art.layout === "image-left";
            const imageOrder = imageFirst ? 1 : 2;
            const contentOrder = imageFirst ? 2 : 1;

            return (
              <Row key={art.id} className="space_ba_info">
                <Col
                  sm={12}
                  xs={12}
                  md={{ span: 5, order: imageOrder }}
                  lg={{ span: 5, order: imageOrder }}
                  xl={{ span: 5, order: imageOrder }}
                >
                  <ModalImage
                    hideDownload="true"
                    small={art.imgSmall}
                    large={art.imgLarge}
                    alt={art.title}
                  />
                </Col>

                <Col
                  sm={12}
                  xs={12}
                  md={{ span: 7, order: contentOrder }}
                  lg={{ span: 7, order: contentOrder }}
                  xl={{ span: 7, order: contentOrder }}
                >
                  <div>
                    {art.title && (
                      <h4
                        data-aos="fade-up"
                        data-aos-duration="2000"
                        className="artist_name_ba"
                      >
                        {art.title}
                      </h4>
                    )}
                    {art.content && (
                      <p
                        data-aos="fade-up"
                        data-aos-duration="2000"
                        className="artist_bio_ba"
                        dangerouslySetInnerHTML={{ __html: art.content }}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default BluesArt;
